var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 41.9899C28 45.7021 29.475 49.2622 32.1005 51.8872C34.726 54.5121 38.287 55.9867 42 55.9867C45.713 55.9867 49.274 54.5121 51.8995 51.8872C54.525 49.2622 56 45.7021 56 41.9899C56 38.2778 54.525 34.7176 51.8995 32.0927C49.274 29.4678 45.713 27.9932 42 27.9932C38.287 27.9932 34.726 29.4678 32.1005 32.0927C29.475 34.7176 28 38.2778 28 41.9899V41.9899Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9998 61.9847L51.8984 51.8857",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7253 26.5061C24.1157 24.8546 21.0884 23.9833 18 23.9946C14.0813 23.9639 10.2877 25.3721 7.3385 27.952C4.38932 30.5319 2.48973 34.1042 2 37.9914",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9979C9 13.3843 9.94821 15.673 11.636 17.3604C13.3239 19.0479 15.6131 19.9959 18 19.9959C20.3869 19.9959 22.6761 19.0479 24.364 17.3604C26.0518 15.673 27 13.3843 27 10.9979C27 8.61153 26.0518 6.32287 24.364 4.63543C22.6761 2.94799 20.3869 2 18 2C15.6131 2 13.3239 2.94799 11.636 4.63543C9.94821 6.32287 9 8.61153 9 10.9979V10.9979Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 8.99839C37 10.8545 37.7375 12.6345 39.0503 13.947C40.363 15.2594 42.1435 15.9968 44 15.9968C45.8565 15.9968 47.637 15.2594 48.9497 13.947C50.2625 12.6345 51 10.8545 51 8.99839C51 7.1423 50.2625 5.36223 48.9497 4.04978C47.637 2.73733 45.8565 2 44 2C42.1435 2 40.363 2.73733 39.0503 4.04978C37.7375 5.36223 37 7.1423 37 8.99839V8.99839Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3996 23.9949C53.4448 22.3432 52.1098 20.943 50.5053 19.9104C48.9009 18.8778 47.0733 18.2426 45.1742 18.0576C43.2751 17.8725 41.3592 18.1429 39.5855 18.8463C37.8118 19.5496 36.2315 20.6657 34.9756 22.102",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyClients);
export default __webpack_public_path__ + "static/media/EmptyClients.99c882a8ea5bdb5ea04ef0333d78b0a3.svg";
export { ForwardRef as ReactComponent };